export const colorSchemas = {
  'Schema1': {
    'colors': {
      'theme_design/colors/color_primary': '#404040',
      'theme_design/colors/color_secondry': '#00adee',
      'theme_design/colors/color_additional': '#888',
      'theme_design/colors/color_primary_text_color': '#333'
    },
    'typography': {
      'theme_design/defined_fonts/google_fonts_string': 'https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&family=Raleway:wght@400;600;700;800&display=swap',
      'theme_design/defined_fonts/font_stacks_string': 'Arial, \'Helvetica Neue\', Helvetica, sans-serif; Verdana, Geneva, sans-serif; Georgia, serif',
      'theme_design/font/body_font_size': '14',
      'theme_design/font/body_font_family': '\'Montserrat\'',
      'theme_design/font_fallback/body_font_stack': 'Arial, \'Helvetica Neue\', Helvetica, sans-serif',
      'theme_design/font/heading1_font_family': '\'Raleway\'',
      'theme_design/font/heading1_font_color': '#000',
      'theme_design/font/heading1_font_size': '32',
      'theme_design/font/heading1_font_weight': '400',
      'theme_design/font/heading1_text_transform': 'capitalize',
      'theme_design/font/heading1_line_height': '1.2',
      'theme_design/font/heading2_font_family': '\'Raleway\'',
      'theme_design/font/heading2_font_color': '#000',
      'theme_design/font/heading2_font_size': '30',
      'theme_design/font/heading2_font_weight': '400',
      'theme_design/font/heading2_text_transform': 'capitalize',
      'theme_design/font/heading2_line_height': '1.2',
      'theme_design/font/heading3_font_family': '\'Raleway\'',
      'theme_design/font/heading3_font_color': '#000',
      'theme_design/font/heading3_font_size': '26',
      'theme_design/font/heading3_font_weight': '400',
      'theme_design/font/heading3_text_transform': 'capitalize',
      'theme_design/font/heading3_line_height': '1.2',
      'theme_design/font/heading4_font_family': '\'Raleway\'',
      'theme_design/font/heading4_font_color': '#000',
      'theme_design/font/heading4_font_size': '20',
      'theme_design/font/heading4_font_weight': '400',
      'theme_design/font/heading4_text_transform': 'capitalize',
      'theme_design/font/heading4_line_height': '1.2',
      'theme_design/font/heading5_font_family': '\'Raleway\'',
      'theme_design/font/heading5_font_color': '#000',
      'theme_design/font/heading5_font_size': '18',
      'theme_design/font/heading5_font_weight': '400',
      'theme_design/font/heading5_text_transform': 'capitalize',
      'theme_design/font/heading5_line_height': '1.2',
      'theme_design/font/heading6_font_family': '\'Raleway\'',
      'theme_design/font/heading6_font_color': '#333',
      'theme_design/font/heading6_font_size': '16',
      'theme_design/font/heading6_font_weight': '400',
      'theme_design/font/heading6_text_transform': 'capitalize',
      'theme_design/font/heading6_line_height': '1.2',
      'theme_design/font/paragraph_font_family': '\'Raleway\'',
      'theme_design/font/paragraph_font_color': '#333',
      'theme_design/font/paragraph_font_size': '16',
      'theme_design/font/paragraph_line_height': '1.4',
      'theme_design/font/list_style_type': 'disc',
      'theme_design/header/header_bg_color': '#141414'
    },
    'links': {
      'theme_design/colors/link_color': '#000',
      'theme_design/colors/link_hover_color': '#00adee',
      'theme_design/colors/link_text_decoration': 'none',
      'theme_design/colors/link_text_decoration_hover': 'none',
      'theme_design/colors/link_font_weight': '600'
    },
    'buttons': {
      'theme_design/colors/button_bg_color': 'rgba(0, 0, 0, 0.4)',
      'theme_design/colors/button_color': '#fff',
      'theme_design/colors/button_hover_bg_color': '#00adee',
      'theme_design/colors/button_hover_color': '#fff',
      'theme_design/colors/button_font_size': '16',
      'theme_design/colors/button_font_family': '\'Montserrat\'',
      'theme_design/colors/button_text_transform': 'uppercase',
      'theme_design/colors/button_font_weight': '500',
      'theme_design/colors/button_font_style': 'normal',
      'theme_design/colors/button_border_radius': '0',
      'theme_design/colors/button_border': '1px solid #00adee',
      'theme_design/colors/button_border_hover': '1px solid #00adee'
    },
    'labels': {
      'theme_design/colors/label_new_bg_color': '#00adee',
      'theme_design/colors/label_new_color': '#fff',
      'theme_design/colors/label_sale_bg_color': '#00adee',
      'theme_design/colors/label_sale_color': '#fff',
    },
    'header': {
      'theme_design/header/header_bg_color': '#141414',
      'theme_design/header/top_border_color': '#00adee',
      'theme_design/header_primary/text_font_size': '14',
      'theme_design/header_primary/text_color': '#fff',
      'theme_design/header_primary/text_link_color': '#fff',
      'theme_design/header_primary/text_link_hover_color': '#fff',
      'theme_design/header_primary/button_color': '#fff',
      'theme_design/header_primary/button_hover_color': '#fff',
      'theme_design/header_primary/button_background': 'rgba(0, 0, 0, 0.4)',
      'theme_design/header_primary/button_hover_background': '#00adee'
    },
    'mobile': {
      'theme_design/m_header/tab_item_bg_color': '#00adee',
      'theme_design/m_header/tab_item_color': '#fff',
      'theme_design/m_header/counter_bg_color': '#333',
      'theme_design/m_header/counter_bg_active_color': '#fff',
      'theme_design/m_header/sub_menu_bg': '#00adee',
      'theme_design/m_header/sub_menu_color': '#fff',
      'theme_design/m_header/sub_menu_font_family': '\'Montserrat\'',
      'theme_design/m_header/sub_menu_text_transform': 'uppercase',
      'theme_design/m_header/sub_menu_font_size': '16',
      'theme_design/m_header/sub_menu_font_weight': '500'
    },
    'menu': {
      'theme_design/nav/outer_menu_bg_color': '#00adee',
      'theme_design/nav/color': '#fff',
      'theme_design/nav/hover_bg_color': '#00adee',
      'theme_design/nav/hover_color': '#070707',
      'theme_design/nav/font_family': '\'Montserrat\'',
      'theme_design/nav/text_transform': 'uppercase',
      'theme_design/nav/font_size': '16',
      'theme_design/nav/font_weight': '600',
      'theme_design/nav/text_decoration': 'none',
      'theme_design/nav/text_decoration_hover': 'none',
      'theme_design/nav/letter_spacing': '0',
      'theme_design/nav/is_menu_item_underline_effect': '0',
      'theme_design/nav/underline_height': '4px',
      'theme_design/nav/underline_color': '#fff',
      'theme_design/nav/dropdown_bg_color': '#00adee',
      'theme_design/nav/dropdown_item_hover_bg_color': '#00adee',
      'theme_design/nav/dropdown_link_color': '#fff',
      'theme_design/nav/dropdown_link_hover_color': '#070707',
      'theme_design/nav/dropdown_font_family': '\'Montserrat\'',
      'theme_design/nav/dropdown_text_transform': 'capitalize',
      'theme_design/nav/dropdown_font_size': '16',
      'theme_design/nav/dropdown_font_weight': '400',
      'theme_design/nav/dropdown_text_decoration': 'none',
      'theme_design/nav/dropdown_text_decoration_hover': 'none',
      'theme_design/nav/dropdown_item_is_border_bottom': '0',
      'theme_design/nav/dropdown_item_border_bottom': 'none'
    },
    'footer': {
      'theme_design/footer/bg_color': '#141414',
      'theme_design/footer/color': '#fff',
      'theme_design/footer/link_color': '#fff',
      'theme_design/footer/link_hover_color': '#00adee',
      'theme_design/footer/border_top': 'none',
      'theme_design/footer/button_bg_color': '#000',
      'theme_design/footer/button_color': '#fff',
      'theme_design/footer/button_hover_bg_color': '#00adee',
      'theme_design/footer/button_hover_color': '#fff',
      'theme_design/footer_bottom/color': '#fff',
      'theme_design/footer_bottom/link_color': '#fff',
      'theme_design/footer_bottom/link_hover_color': '#00adee',
      'theme_design/footer_bottom/bg_color': '#000',
      'theme_design/footer_tagline/bg_color': '#333',
      'theme_design/footer_tagline/color': '#fff',
      'theme_design/footer_tagline/font_size': '32',
      'theme_design/footer_tagline/font_weight': '400',
      'theme_design/premium_plus_footer/text_transform': 'capitalize',
      'theme_design/premium_plus_footer/newsletter_bg_color': '#fff',
      'theme_design/premium_plus_footer/font_size': 'inherit',
      'theme_design/premium_plus_footer/font_weight': '400'
    },
    'category_page': {
      'theme_design/colors/price_color': '#000',
      'theme_design/colors/price_font_size': '16',
      'theme_design/colors/price_font_weight': '400',
      'theme_design/colors/rating_active_color': '#333',
      'theme_design/colors/product_name_color': '#000',
      'theme_design/colors/product_name_font_size': '18',
      'theme_design/colors/product_name_font_weight': '400',
      'theme_design/colors/product_name_text_transform': 'uppercase',
      'theme_design/colors/product_name_text_align': 'center',
      'theme_design/category/category_promo_font_family': '\'Montserrat\'',
      'theme_design/category/category_promo_font_size': '18',
      'theme_design/category/category_promo_font_weight': '700',
      'theme_design/category/category_promo_line_height': '1.2',
      'theme_design/category/category_promo_padding': '10',
      'theme_design/category/category_promo_bg_color': '#f5f5f5',
      'theme_design/category/category_promo_color': '#333'
    },
    'product_page': {
      'theme_design/product_page/product_promo_font_family': '\'Montserrat\'',
      'theme_design/product_page/product_promo_font_size': '16',
      'theme_design/product_page/product_promo_font_weight': '600',
      'theme_design/product_page/product_promo_line_height': '1.2',
      'theme_design/product_page/product_promo_padding': '10',
      'theme_design/product_page/product_promo_bg_color': '#f5f5f5',
      'theme_design/product_page/product_promo_color': '#333',
      'theme_design/product_page/product_tabs_bg_color': '#000',
      'theme_design/product_page/product_tabs_color': '#fff',
      'theme_design/product_page/product_tabs_bg_color_active': '#00adee',
      'theme_design/product_page/product_tabs_color_active': '#fff'
    },
    'cart_page': {
      'theme_design/main/login_promo_bg_color': '#000',
      'theme_design/main/login_promo_color': '#fff',
      'theme_design/main/login_promo_title_font_size': '22',
      'theme_design/main/login_promo_title_font_weight': '400',
      'theme_design/main/login_promo_font_family': '\'Montserrat\'',
      'theme_design/main/login_promo_desc_font_size': '14',
      'theme_design/main/login_promo_text_transform': 'uppercase'
    },
    'homepage_cta': {
      'theme_design/cta/cta_mask_bg': 'rgba(20, 20, 20, 0.8)',
      'theme_design/cta/cta_mask_title_color': '#fff',
      'theme_design/cta/cta_mask_link_color': '#fff',
      'theme_design/cta/cta_mask_link_color_hover': '#00adee',
      'theme_design/cta/cta_mask_button_bg': '#000',
      'theme_design/cta/cta_mask_button_color': '#fff',
      'theme_design/cta/cta_mask_button_bg_hover': '#00adee',
      'theme_design/cta/cta_mask_button_color_hover': '#fff',
      'theme_design/cta/button_border': '1px solid #00adee',
      'theme_design/cta/button_border_hover': '1px solid #00adee',
      'theme_design/cta/cta_vertical_title_color': '#fff',
      'theme_design/cta/cta_horizontal_top_title_color': '#fff',
      'theme_design/cta/cta_horizontal_bottom_title_color': '#fff',
      'theme_design/cta/cta_title_font_weight': '400'
    },
    'additional_header': {
      'theme_design/premium_plus_homepage/additional_header_bg': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_text_color': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_text_font_size': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_icon_color': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_text_color_hover': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_icon_color_hover': 'inherit'
    },
    'premium_plus_testimonials': {
      'theme_design/premium_plus_homepage/testimonials_bg': 'transparent',
      'theme_design/premium_plus_homepage/testimonials_block_text_color': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_text_font_size': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_text_transform': 'none',
      'theme_design/premium_plus_homepage/testimonials_block_text_font_weight': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_text_font_style': 'normal',
      'theme_design/premium_plus_homepage/testimonials_block_rating_color': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_rating_bg_color': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_author_color': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_author_font_size': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_author_font_weight': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_author_transform': 'none',
      'theme_design/premium_plus_homepage/testimonials_block_author_font_style': 'normal'
    },
    'premium_plus_blog': {
      'theme_design/premium_plus_homepage/blog_block_bg': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_main_heading_color': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_main_heading_font_size': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_text_color': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_text_font_size': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_bg': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_color': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_border_color': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_bg_hover': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_color_hover': 'inherit'
    },
    'premium_plus_instagram': {
      'theme_design/premium_plus_homepage/instagram_block_mask_bg': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_main_heading_color': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_main_heading_font_size': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_bg': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_color': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_border_color': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_bg_hover': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_color_hover': 'inherit'
    },
    'premium_plus_cta': {
      'theme_design/premium_plus_homepage/premium_plus_cta_title_color': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_title_font_size': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_title_transform': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_title_font_weight': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_title_font_style': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_item_bg': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_color': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_font_size': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_transform': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_font_weight': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_font_style': 'inherit'
    }
  },
  'Schema2': {
    'colors': {
      'theme_design/colors/color_primary': '#353533',
      'theme_design/colors/color_secondry': '#fff',
      'theme_design/colors/color_additional': '#000',
      'theme_design/colors/color_primary_text_color': '#000'
    },
    'typography': {
      'theme_design/defined_fonts/google_fonts_string': 'https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&family=Open+Sans&display=swap',
      'theme_design/defined_fonts/font_stacks_string': 'Arial, \'Helvetica Neue\', Helvetica, sans-serif; Verdana, Geneva, sans-serif; Georgia, serif',
      'theme_design/font/body_font_size': '14',
      'theme_design/font/body_font_family': '\'Montserrat\'',
      'theme_design/font_fallback/body_font_stack': 'Arial, \'Helvetica Neue\', Helvetica, sans-serif',
      'theme_design/font/heading1_font_family': '\'Montserrat\'',
      'theme_design/font/heading1_font_color': '#000',
      'theme_design/font/heading1_font_size': '32',
      'theme_design/font/heading1_font_weight': '400',
      'theme_design/font/heading1_text_transform': 'capitalize',
      'theme_design/font/heading1_line_height': '1.2',
      'theme_design/font/heading2_font_family': '\'Montserrat\'',
      'theme_design/font/heading2_font_color': '#000',
      'theme_design/font/heading2_font_size': '30',
      'theme_design/font/heading2_font_weight': '400',
      'theme_design/font/heading2_text_transform': 'capitalize',
      'theme_design/font/heading2_line_height': '1.2',
      'theme_design/font/heading3_font_family': '\'Montserrat\'',
      'theme_design/font/heading3_font_color': '#000',
      'theme_design/font/heading3_font_size': '26',
      'theme_design/font/heading3_font_weight': '400',
      'theme_design/font/heading3_text_transform': 'capitalize',
      'theme_design/font/heading3_line_height': '1.2',
      'theme_design/font/heading4_font_family': '\'Montserrat\'',
      'theme_design/font/heading4_font_color': '#000',
      'theme_design/font/heading4_font_size': '20',
      'theme_design/font/heading4_font_weight': '400',
      'theme_design/font/heading4_text_transform': 'capitalize',
      'theme_design/font/heading4_line_height': '1.2',
      'theme_design/font/heading5_font_family': '\'Montserrat\'',
      'theme_design/font/heading5_font_color': '#000',
      'theme_design/font/heading5_font_size': '18',
      'theme_design/font/heading5_font_weight': '400',
      'theme_design/font/heading5_text_transform': 'capitalize',
      'theme_design/font/heading5_line_height': '1.2',
      'theme_design/font/heading6_font_family': '\'Montserrat\'',
      'theme_design/font/heading6_font_color': '#333',
      'theme_design/font/heading6_font_size': '16',
      'theme_design/font/heading6_font_weight': '400',
      'theme_design/font/heading6_text_transform': 'capitalize',
      'theme_design/font/heading6_line_height': '1.2',
      'theme_design/font/paragraph_font_family': '\'Montserrat\'',
      'theme_design/font/paragraph_font_color': '#000',
      'theme_design/font/paragraph_font_size': '16',
      'theme_design/font/paragraph_line_height': '1.4',
      'theme_design/font/list_style_type': 'disc'
    },
    'links': {
      'theme_design/colors/link_color': '#014f93',
      'theme_design/colors/link_hover_color': '#014f93',
      'theme_design/colors/link_text_decoration': 'none',
      'theme_design/colors/link_text_decoration_hover': 'none',
      'theme_design/colors/link_font_weight': '400'
    },
    'buttons': {
      'theme_design/colors/button_bg_color': '#014f93',
      'theme_design/colors/button_color': '#fff',
      'theme_design/colors/button_hover_bg_color': '#000',
      'theme_design/colors/button_hover_color': '#fff',
      'theme_design/colors/button_font_size': '16',
      'theme_design/colors/button_font_family': '\'Montserrat\'',
      'theme_design/colors/button_text_transform': 'uppercase',
      'theme_design/colors/button_font_weight': '400',
      'theme_design/colors/button_font_style': 'normal',
      'theme_design/colors/button_border_radius': '2px',
      'theme_design/colors/button_border': 'none',
      'theme_design/colors/button_border_hover': 'none'
    },
    'labels': {
      'theme_design/colors/label_new_bg_color': '#000',
      'theme_design/colors/label_new_color': '#fff',
      'theme_design/colors/label_sale_bg_color': '#000',
      'theme_design/colors/label_sale_color': '#fff',
    },
    'header': {
      'theme_design/header/header_bg_color': '#fff',
      'theme_design/header/top_border_color': 'rgba(20, 20, 20, 0.8)',
      'theme_design/header_primary/text_font_size': '14',
      'theme_design/header_primary/text_color': '#000',
      'theme_design/header_primary/text_link_color': '#000',
      'theme_design/header_primary/text_link_hover_color': '#000',
      'theme_design/header_primary/button_color': '#fff',
      'theme_design/header_primary/button_hover_color': '#fff',
      'theme_design/header_primary/button_background': '#014f93',
      'theme_design/header_primary/button_hover_background': '#000'
    },
    'mobile': {
      'theme_design/m_header/tab_item_bg_color': 'rgba(20, 20, 20, 0.8)',
      'theme_design/m_header/tab_item_color': '#fff',
      'theme_design/m_header/counter_bg_color': '#000',
      'theme_design/m_header/counter_bg_active_color': '#fff',
      'theme_design/m_header/sub_menu_bg': 'rgba(20, 20, 20, 0.8)',
      'theme_design/m_header/sub_menu_color': '#fff',
      'theme_design/m_header/sub_menu_font_family': '\'Montserrat\'',
      'theme_design/m_header/sub_menu_text_transform': 'uppercase',
      'theme_design/m_header/sub_menu_font_size': '13',
      'theme_design/m_header/sub_menu_font_weight': '500'
    },
    'menu': {
      'theme_design/nav/outer_menu_bg_color': 'rgba(20, 20, 20, 0.8)',
      'theme_design/nav/color': '#fff',
      'theme_design/nav/hover_bg_color': 'transparent',
      'theme_design/nav/hover_color': '#fff',
      'theme_design/nav/font_family': '\'Montserrat\'',
      'theme_design/nav/text_transform': 'uppercase',
      'theme_design/nav/font_size': '13',
      'theme_design/nav/font_weight': '400',
      'theme_design/nav/text_decoration': 'none',
      'theme_design/nav/text_decoration_hover': 'none',
      'theme_design/nav/letter_spacing': '0px',
      'theme_design/nav/is_menu_item_underline_effect': '0',
      'theme_design/nav/underline_height': '4px',
      'theme_design/nav/underline_color': '#fff',
      'theme_design/nav/dropdown_bg_color': 'rgba(20, 20, 20, 0.8)',
      'theme_design/nav/dropdown_item_hover_bg_color': 'rgba(0, 0, 0, 0)',
      'theme_design/nav/dropdown_link_color': '#fff',
      'theme_design/nav/dropdown_link_hover_color': '#fff',
      'theme_design/nav/dropdown_font_family': '\'Montserrat\'',
      'theme_design/nav/dropdown_text_transform': 'uppercase',
      'theme_design/nav/dropdown_font_size': '13',
      'theme_design/nav/dropdown_font_weight': '400',
      'theme_design/nav/dropdown_text_decoration': 'none',
      'theme_design/nav/dropdown_text_decoration_hover': 'none',
      'theme_design/nav/dropdown_item_is_border_bottom': '0',
      'theme_design/nav/dropdown_item_border_bottom': 'none'
    },
    'footer': {
      'theme_design/footer/bg_color': '#fff',
      'theme_design/footer/color': '#000',
      'theme_design/footer/link_color': '#014f93',
      'theme_design/footer/link_hover_color': '#014f93',
      'theme_design/footer/border_top': 'none',
      'theme_design/footer/button_bg_color': '#014f93',
      'theme_design/footer/button_color': '#fff',
      'theme_design/footer/button_hover_bg_color': '#000',
      'theme_design/footer/button_hover_color': '#fff',
      'theme_design/footer_bottom/color': '#fff',
      'theme_design/footer_bottom/link_color': '#fff',
      'theme_design/footer_bottom/link_hover_color': '#b7b7b7',
      'theme_design/footer_bottom/bg_color': '#000',
      'theme_design/footer_tagline/bg_color': 'rgba(20, 20, 20, 0.8)',
      'theme_design/footer_tagline/color': '#fff',
      'theme_design/footer_tagline/font_size': '32',
      'theme_design/footer_tagline/font_weight': '400',
      'theme_design/premium_plus_footer/text_transform': 'capitalize',
      'theme_design/premium_plus_footer/newsletter_bg_color': '#fff',
      'theme_design/premium_plus_footer/font_size': 'inherit',
      'theme_design/premium_plus_footer/font_weight': '400'
    },
    'category_page': {
      'theme_design/colors/price_color': '#014f93',
      'theme_design/colors/price_font_size': '16',
      'theme_design/colors/price_font_weight': '400',
      'theme_design/colors/rating_active_color': '#014f93',
      'theme_design/colors/product_name_color': '#000',
      'theme_design/colors/product_name_font_size': '18',
      'theme_design/colors/product_name_font_weight': '400',
      'theme_design/colors/product_name_text_transform': 'uppercase',
      'theme_design/colors/product_name_text_align': 'center',
      'theme_design/category/category_promo_font_family': '\'Montserrat\'',
      'theme_design/category/category_promo_font_size': '18',
      'theme_design/category/category_promo_font_weight': '700',
      'theme_design/category/category_promo_line_height': '1.5',
      'theme_design/category/category_promo_padding': '10',
      'theme_design/category/category_promo_bg_color': '#f5f5f5',
      'theme_design/category/category_promo_color': '#000'
    },
    'product_page': {
      'theme_design/product_page/product_promo_font_family': '\'Montserrat\'',
      'theme_design/product_page/product_promo_font_size': '16',
      'theme_design/product_page/product_promo_font_weight': '600',
      'theme_design/product_page/product_promo_line_height': '1.5',
      'theme_design/product_page/product_promo_padding': '10',
      'theme_design/product_page/product_promo_bg_color': '#f5f5f5',
      'theme_design/product_page/product_promo_color': '#000',
      'theme_design/product_page/product_tabs_bg_color': '#353535',
      'theme_design/product_page/product_tabs_color': '#fff',
      'theme_design/product_page/product_tabs_bg_color_active': '#000',
      'theme_design/product_page/product_tabs_color_active': '#fff'
    },
    'cart_page': {
      'theme_design/main/login_promo_bg_color': '#000',
      'theme_design/main/login_promo_color': '#fff',
      'theme_design/main/login_promo_title_font_size': '22',
      'theme_design/main/login_promo_title_font_weight': '400',
      'theme_design/main/login_promo_font_family': '\'Open Sans\'',
      'theme_design/main/login_promo_desc_font_size': '14',
      'theme_design/main/login_promo_text_transform': 'uppercase'
    },
    'homepage_cta': {
      'theme_design/cta/cta_mask_bg': 'rgba(53, 53, 51, 0.8)',
      'theme_design/cta/cta_mask_title_color': '#fff',
      'theme_design/cta/cta_mask_link_color': '#fff',
      'theme_design/cta/cta_mask_link_color_hover': '#014f93',
      'theme_design/cta/cta_mask_button_bg': '#014f93',
      'theme_design/cta/cta_mask_button_color': '#fff',
      'theme_design/cta/cta_mask_button_bg_hover': '#000',
      'theme_design/cta/cta_mask_button_color_hover': '#fff',
      'theme_design/cta/button_border': 'none',
      'theme_design/cta/button_border_hover': 'none',
      'theme_design/cta/cta_vertical_title_color': '#fff',
      'theme_design/cta/cta_horizontal_top_title_color': '#fff',
      'theme_design/cta/cta_horizontal_bottom_title_color': '#fff',
      'theme_design/cta/cta_title_font_weight': '400'
    },
    'additional_header': {
      'theme_design/premium_plus_homepage/additional_header_bg': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_text_color': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_text_font_size': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_icon_color': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_text_color_hover': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_icon_color_hover': 'inherit'
    },
    'premium_plus_testimonials': {
      'theme_design/premium_plus_homepage/testimonials_bg': 'transparent',
      'theme_design/premium_plus_homepage/testimonials_block_text_color': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_text_font_size': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_text_transform': 'none',
      'theme_design/premium_plus_homepage/testimonials_block_text_font_weight': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_text_font_style': 'normal',
      'theme_design/premium_plus_homepage/testimonials_block_rating_color': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_rating_bg_color': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_author_color': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_author_font_size': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_author_font_weight': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_author_transform': 'none',
      'theme_design/premium_plus_homepage/testimonials_block_author_font_style': 'normal'
    },
    'premium_plus_blog': {
      'theme_design/premium_plus_homepage/blog_block_bg': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_main_heading_color': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_main_heading_font_size': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_text_color': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_text_font_size': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_bg': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_color': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_border_color': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_bg_hover': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_color_hover': 'inherit'
    },
    'premium_plus_instagram': {
      'theme_design/premium_plus_homepage/instagram_block_mask_bg': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_main_heading_color': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_main_heading_font_size': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_bg': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_color': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_border_color': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_bg_hover': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_color_hover': 'inherit'
    },
    'premium_plus_cta': {
      'theme_design/premium_plus_homepage/premium_plus_cta_title_color': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_title_font_size': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_title_transform': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_title_font_weight': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_title_font_style': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_item_bg': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_color': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_font_size': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_transform': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_font_weight': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_font_style': 'inherit'
    }
  },
  'Schema3': {
    'colors': {
      'theme_design/colors/color_primary': '#424242',
      'theme_design/colors/color_secondry': '#2294a4',
      'theme_design/colors/color_additional': '#656f72',
      'theme_design/colors/color_primary_text_color': '#656f72'
    },
    'typography': {
      'theme_design/defined_fonts/google_fonts_string': 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700;800&display=swap',
      'theme_design/defined_fonts/font_stacks_string': 'Arial, \'Helvetica Neue\', Helvetica, sans-serif; Verdana, Geneva, sans-serif; Georgia, serif',
      'theme_design/font/body_font_size': '14',
      'theme_design/font/body_font_family': '\'Open Sans\'',
      'theme_design/font_fallback/body_font_stack': 'Arial, \'Helvetica Neue\', Helvetica, sans-serif',
      'theme_design/font/heading1_font_family': '\'Open Sans\'',
      'theme_design/font/heading1_font_color': '#191b1f',
      'theme_design/font/heading1_font_size': '32',
      'theme_design/font/heading1_font_weight': '400',
      'theme_design/font/heading1_text_transform': 'capitalize',
      'theme_design/font/heading1_line_height': '1.2',
      'theme_design/font/heading2_font_family': '\'Open Sans\'',
      'theme_design/font/heading2_font_color': '#191b1f',
      'theme_design/font/heading2_font_size': '30',
      'theme_design/font/heading2_font_weight': '400',
      'theme_design/font/heading2_text_transform': 'capitalize',
      'theme_design/font/heading2_line_height': '1.2',
      'theme_design/font/heading3_font_family': '\'Open Sans\'',
      'theme_design/font/heading3_font_color': '#191b1f',
      'theme_design/font/heading3_font_size': '26',
      'theme_design/font/heading3_font_weight': '400',
      'theme_design/font/heading3_text_transform': 'capitalize',
      'theme_design/font/heading3_line_height': '1.2',
      'theme_design/font/heading4_font_family': '\'Open Sans\'',
      'theme_design/font/heading4_font_color': '#191b1f',
      'theme_design/font/heading4_font_size': '20',
      'theme_design/font/heading4_font_weight': '400',
      'theme_design/font/heading4_text_transform': 'capitalize',
      'theme_design/font/heading4_line_height': '1.2',
      'theme_design/font/heading5_font_family': '\'Open Sans\'',
      'theme_design/font/heading5_font_color': '#000',
      'theme_design/font/heading5_font_size': '18',
      'theme_design/font/heading5_font_weight': '400',
      'theme_design/font/heading5_text_transform': 'capitalize',
      'theme_design/font/heading5_line_height': '1.2',
      'theme_design/font/heading6_font_family': '\'Open Sans\'',
      'theme_design/font/heading6_font_color': '#333',
      'theme_design/font/heading6_font_size': '16',
      'theme_design/font/heading6_font_weight': '400',
      'theme_design/font/heading6_text_transform': 'capitalize',
      'theme_design/font/heading6_line_height': '1.2',
      'theme_design/font/paragraph_font_family': '\'Open Sans\'',
      'theme_design/font/paragraph_font_color': '#656f72',
      'theme_design/font/paragraph_font_size': '15',
      'theme_design/font/paragraph_line_height': '1.4',
      'theme_design/font/list_style_type': 'disc'
    },
    'links': {
      'theme_design/colors/link_color': '#2294a4',
      'theme_design/colors/link_hover_color': '#656f72',
      'theme_design/colors/link_text_decoration': 'underline',
      'theme_design/colors/link_text_decoration_hover': 'none',
      'theme_design/colors/link_font_weight': '400'
    },
    'buttons': {
      'theme_design/colors/button_bg_color': '#2294a4',
      'theme_design/colors/button_color': '#fff',
      'theme_design/colors/button_hover_bg_color': '#dcc7aa',
      'theme_design/colors/button_hover_color': '#fff',
      'theme_design/colors/button_font_size': '14',
      'theme_design/colors/button_font_family': '\'Open Sans\'',
      'theme_design/colors/button_text_transform': 'uppercase',
      'theme_design/colors/button_font_weight': '400',
      'theme_design/colors/button_font_style': 'normal',
      'theme_design/colors/button_border_radius': '3px',
      'theme_design/colors/button_border': 'none',
      'theme_design/colors/button_border_hover': 'none'
    },
    'labels': {
      'theme_design/colors/label_new_bg_color': '#2294a4',
      'theme_design/colors/label_new_color': '#fff',
      'theme_design/colors/label_sale_bg_color': '#2294a4',
      'theme_design/colors/label_sale_color': '#fff',
    },
    'header': {
      'theme_design/header/header_bg_color': '#fff',
      'theme_design/header/top_border_color': '#656f72',
      'theme_design/header_primary/text_font_size': '14',
      'theme_design/header_primary/text_color': '#656f72',
      'theme_design/header_primary/text_link_color': '#656f72',
      'theme_design/header_primary/text_link_hover_color': '#2294a4',
      'theme_design/header_primary/button_color': '#fff',
      'theme_design/header_primary/button_hover_color': '#fff',
      'theme_design/header_primary/button_background': '#2294a4',
      'theme_design/header_primary/button_hover_background': '#dcc7aa'
    },
    'mobile': {
      'theme_design/m_header/tab_item_bg_color': '#2294a4',
      'theme_design/m_header/tab_item_color': '#fff',
      'theme_design/m_header/counter_bg_color': '#333',
      'theme_design/m_header/counter_bg_active_color': '#333',
      'theme_design/m_header/sub_menu_bg': '#2294a4',
      'theme_design/m_header/sub_menu_color': '#fff',
      'theme_design/m_header/sub_menu_font_family': '\'Open Sans\'',
      'theme_design/m_header/sub_menu_text_transform': 'uppercase',
      'theme_design/m_header/sub_menu_font_size': '15',
      'theme_design/m_header/sub_menu_font_weight': '400'
    },
    'menu': {
      'theme_design/nav/outer_menu_bg_color': '#2294a4',
      'theme_design/nav/color': '#fff',
      'theme_design/nav/hover_bg_color': '#2294a4',
      'theme_design/nav/hover_color': '#fff',
      'theme_design/nav/font_family': '\'Open Sans\'',
      'theme_design/nav/text_transform': 'uppercase',
      'theme_design/nav/font_size': '14',
      'theme_design/nav/font_weight': '700',
      'theme_design/nav/text_decoration': 'none',
      'theme_design/nav/text_decoration_hover': 'none',
      'theme_design/nav/letter_spacing': '0px',
      'theme_design/nav/is_menu_item_underline_effect': '1',
      'theme_design/nav/underline_height': '3px',
      'theme_design/nav/underline_color': '#fff',
      'theme_design/nav/dropdown_bg_color': '#fff',
      'theme_design/nav/dropdown_item_hover_bg_color': '#fff',
      'theme_design/nav/dropdown_link_color': 'rgba(66, 66, 66, 0.8)',
      'theme_design/nav/dropdown_link_hover_color': '#424242',
      'theme_design/nav/dropdown_font_family': '\'Open Sans\'',
      'theme_design/nav/dropdown_text_transform': 'uppercase',
      'theme_design/nav/dropdown_font_size': '15',
      'theme_design/nav/dropdown_font_weight': '400',
      'theme_design/nav/dropdown_text_decoration': 'none',
      'theme_design/nav/dropdown_text_decoration_hover': 'none',
      'theme_design/nav/dropdown_item_is_border_bottom': '0',
      'theme_design/nav/dropdown_item_border_bottom': 'none'
    },
    'footer': {
      'theme_design/footer/bg_color': '#f5f9f9',
      'theme_design/footer/color': '#656f72',
      'theme_design/footer/link_color': '#2294a4',
      'theme_design/footer/link_hover_color': '#656f72',
      'theme_design/footer/border_top': 'none',
      'theme_design/footer/button_bg_color': '#2294a4',
      'theme_design/footer/button_color': '#fff',
      'theme_design/footer/button_hover_bg_color': '#dcc7aa',
      'theme_design/footer/button_hover_color': '#fff',
      'theme_design/footer_bottom/color': '#fff',
      'theme_design/footer_bottom/link_color': '#fff',
      'theme_design/footer_bottom/link_hover_color': '#2294a4',
      'theme_design/footer_bottom/bg_color': '#0d3545',
      'theme_design/footer_tagline/bg_color': '#2294a4',
      'theme_design/footer_tagline/color': '#fff',
      'theme_design/footer_tagline/font_size': '32',
      'theme_design/footer_tagline/font_weight': '400',
      'theme_design/premium_plus_footer/text_transform': 'capitalize',
      'theme_design/premium_plus_footer/newsletter_bg_color': '#fff',
      'theme_design/premium_plus_footer/font_size': 'inherit',
      'theme_design/premium_plus_footer/font_weight': '400'
    },
    'category_page': {
      'theme_design/colors/price_color': '#2294a4',
      'theme_design/colors/price_font_size': '16',
      'theme_design/colors/price_font_weight': '400',
      'theme_design/colors/rating_active_color': '#2294a4',
      'theme_design/colors/product_name_color': '#191b1f',
      'theme_design/colors/product_name_font_size': '18',
      'theme_design/colors/product_name_font_weight': '400',
      'theme_design/colors/product_name_text_transform': 'uppercase',
      'theme_design/colors/product_name_text_align': 'center',
      'theme_design/category/category_promo_font_family': '\'Open Sans\'',
      'theme_design/category/category_promo_font_size': '18',
      'theme_design/category/category_promo_font_weight': '700',
      'theme_design/category/category_promo_line_height': '1.5',
      'theme_design/category/category_promo_padding': '10',
      'theme_design/category/category_promo_bg_color': '#f5f5f5',
      'theme_design/category/category_promo_color': '#656f72'
    },
    'product_page': {
      'theme_design/product_page/product_promo_font_family': '\'Open Sans\'',
      'theme_design/product_page/product_promo_font_size': '16',
      'theme_design/product_page/product_promo_font_weight': '600',
      'theme_design/product_page/product_promo_line_height': '1.5',
      'theme_design/product_page/product_promo_padding': '10',
      'theme_design/product_page/product_promo_bg_color': '#f5f5f5',
      'theme_design/product_page/product_promo_color': '#656f72',
      'theme_design/product_page/product_tabs_bg_color': '#2294a4',
      'theme_design/product_page/product_tabs_color': '#fff',
      'theme_design/product_page/product_tabs_bg_color_active': '#dcc7aa',
      'theme_design/product_page/product_tabs_color_active': '#fff'
    },
    'cart_page': {
      'theme_design/main/login_promo_bg_color': '#2294a4',
      'theme_design/main/login_promo_color': '#fff',
      'theme_design/main/login_promo_title_font_size': '22',
      'theme_design/main/login_promo_title_font_weight': '400',
      'theme_design/main/login_promo_font_family': '\'Open Sans\'',
      'theme_design/main/login_promo_desc_font_size': '14',
      'theme_design/main/login_promo_text_transform': 'uppercase'
    },
    'homepage_cta': {
      'theme_design/cta/cta_mask_bg': 'rgba(53, 53, 51, 0.8)',
      'theme_design/cta/cta_mask_title_color': '#fff',
      'theme_design/cta/cta_mask_link_color': '#fff',
      'theme_design/cta/cta_mask_link_color_hover': '#2294a4',
      'theme_design/cta/cta_mask_button_bg': '#2294a4',
      'theme_design/cta/cta_mask_button_color': '#fff',
      'theme_design/cta/cta_mask_button_bg_hover': '#dcc7aa',
      'theme_design/cta/cta_mask_button_color_hover': '#fff',
      'theme_design/cta/button_border': 'none',
      'theme_design/cta/button_border_hover': 'none',
      'theme_design/cta/cta_vertical_title_color': '#fff',
      'theme_design/cta/cta_horizontal_top_title_color': '#fff',
      'theme_design/cta/cta_horizontal_bottom_title_color': '#fff',
      'theme_design/cta/cta_title_font_weight': '400'
    },
    'additional_header': {
      'theme_design/premium_plus_homepage/additional_header_bg': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_text_color': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_text_font_size': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_icon_color': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_text_color_hover': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_icon_color_hover': 'inherit'
    },
    'premium_plus_testimonials': {
      'theme_design/premium_plus_homepage/testimonials_bg': 'transparent',
      'theme_design/premium_plus_homepage/testimonials_block_text_color': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_text_font_size': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_text_transform': 'none',
      'theme_design/premium_plus_homepage/testimonials_block_text_font_weight': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_text_font_style': 'normal',
      'theme_design/premium_plus_homepage/testimonials_block_rating_color': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_rating_bg_color': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_author_color': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_author_font_size': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_author_font_weight': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_author_transform': 'none',
      'theme_design/premium_plus_homepage/testimonials_block_author_font_style': 'normal'
    },
    'premium_plus_blog': {
      'theme_design/premium_plus_homepage/blog_block_bg': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_main_heading_color': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_main_heading_font_size': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_text_color': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_text_font_size': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_bg': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_color': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_border_color': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_bg_hover': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_color_hover': 'inherit'
    },
    'premium_plus_instagram': {
      'theme_design/premium_plus_homepage/instagram_block_mask_bg': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_main_heading_color': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_main_heading_font_size': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_bg': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_color': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_border_color': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_bg_hover': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_color_hover': 'inherit'
    },
    'premium_plus_cta': {
      'theme_design/premium_plus_homepage/premium_plus_cta_title_color': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_title_font_size': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_title_transform': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_title_font_weight': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_title_font_style': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_item_bg': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_color': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_font_size': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_transform': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_font_weight': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_font_style': 'inherit'
    }
  },
  'Schema4': {
    'colors': {
      'theme_design/colors/color_primary': '#444',
      'theme_design/colors/color_secondry': '#f0d8e7',
      'theme_design/colors/color_additional': '#f0d8e7',
      'theme_design/colors/color_primary_text_color': '#444'
    },
    'typography': {
      'theme_design/defined_fonts/google_fonts_string': 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700;800&family=Poppins:wght@300;400;500;600;700;800&display=swap',
      'theme_design/defined_fonts/font_stacks_string': 'Arial, \'Helvetica Neue\', Helvetica, sans-serif; Verdana, Geneva, sans-serif; Georgia, serif',
      'theme_design/font/body_font_size': '14',
      'theme_design/font/body_font_family': '\'Open Sans\'',
      'theme_design/font_fallback/body_font_stack': 'Arial, \'Helvetica Neue\', Helvetica, sans-serif',
      'theme_design/font/heading1_font_family': '\'Open Sans\'',
      'theme_design/font/heading1_font_color': '#000',
      'theme_design/font/heading1_font_size': '32',
      'theme_design/font/heading1_font_weight': '400',
      'theme_design/font/heading1_text_transform': 'capitalize',
      'theme_design/font/heading1_line_height': '1.2',
      'theme_design/font/heading2_font_family': '\'Open Sans\'',
      'theme_design/font/heading2_font_color': '#000',
      'theme_design/font/heading2_font_size': '30',
      'theme_design/font/heading2_font_weight': '400',
      'theme_design/font/heading2_text_transform': 'capitalize',
      'theme_design/font/heading2_line_height': '1.2',
      'theme_design/font/heading3_font_family': '\'Open Sans\'',
      'theme_design/font/heading3_font_color': '#000',
      'theme_design/font/heading3_font_size': '26',
      'theme_design/font/heading3_font_weight': '400',
      'theme_design/font/heading3_text_transform': 'capitalize',
      'theme_design/font/heading3_line_height': '1.2',
      'theme_design/font/heading4_font_family': '\'Open Sans\'',
      'theme_design/font/heading4_font_color': '#000',
      'theme_design/font/heading4_font_size': '20',
      'theme_design/font/heading4_font_weight': '400',
      'theme_design/font/heading4_text_transform': 'capitalize',
      'theme_design/font/heading4_line_height': '1.2',
      'theme_design/font/heading5_font_family': '\'Open Sans\'',
      'theme_design/font/heading5_font_color': '#000',
      'theme_design/font/heading5_font_size': '18',
      'theme_design/font/heading5_font_weight': '400',
      'theme_design/font/heading5_text_transform': 'capitalize',
      'theme_design/font/heading5_line_height': '1.2',
      'theme_design/font/heading6_font_family': '\'Open Sans\'',
      'theme_design/font/heading6_font_color': '#000',
      'theme_design/font/heading6_font_size': '16',
      'theme_design/font/heading6_font_weight': '400',
      'theme_design/font/heading6_text_transform': 'capitalize',
      'theme_design/font/heading6_line_height': '1.2',
      'theme_design/font/paragraph_font_family': '\'Open Sans\'',
      'theme_design/font/paragraph_font_color': '#656f72',
      'theme_design/font/paragraph_font_size': '15',
      'theme_design/font/paragraph_line_height': '1.4',
      'theme_design/font/list_style_type': 'disc'
    },
    'links': {
      'theme_design/colors/link_color': '#f20cb5',
      'theme_design/colors/link_hover_color': '#444',
      'theme_design/colors/link_text_decoration': 'none',
      'theme_design/colors/link_text_decoration_hover': 'none',
      'theme_design/colors/link_font_weight': '500'
    },
    'buttons': {
      'theme_design/colors/button_bg_color': '#f20cb5',
      'theme_design/colors/button_color': '#000',
      'theme_design/colors/button_hover_bg_color': '#fff',
      'theme_design/colors/button_hover_color': '#f20cb5',
      'theme_design/colors/button_font_size': '16',
      'theme_design/colors/button_font_family': '\'Open Sans\'',
      'theme_design/colors/button_text_transform': 'capitalize',
      'theme_design/colors/button_font_weight': '400',
      'theme_design/colors/button_font_style': 'normal',
      'theme_design/colors/button_border_radius': '20px',
      'theme_design/colors/button_border': '1px solid #f20cb5',
      'theme_design/colors/button_border_hover': '1px solid #f20cb5'
    },
    'labels': {
      'theme_design/colors/label_new_bg_color': '#f0d8e7',
      'theme_design/colors/label_new_color': '#444',
      'theme_design/colors/label_sale_bg_color': '#f0d8e7',
      'theme_design/colors/label_sale_color': '#444',
    },
    'header': {
      'theme_design/header/header_bg_color': '#fff',
      'theme_design/header/top_border_color': '#fff',
      'theme_design/header_primary/text_font_size': '14',
      'theme_design/header_primary/text_color': '#444',
      'theme_design/header_primary/text_link_color': '#444',
      'theme_design/header_primary/text_link_hover_color': '#444',
      'theme_design/header_primary/button_color': '#000',
      'theme_design/header_primary/button_hover_color': '#f20cb5',
      'theme_design/header_primary/button_background': '#f20cb5',
      'theme_design/header_primary/button_hover_background': '#fff',
    },
    'mobile': {
      'theme_design/m_header/tab_item_bg_color': '#2294a4',
      'theme_design/m_header/tab_item_color': '#444',
      'theme_design/m_header/counter_bg_color': '#333',
      'theme_design/m_header/counter_bg_active_color': '#fff',
      'theme_design/m_header/sub_menu_bg': '#f0d8e7',
      'theme_design/m_header/sub_menu_color': '#444',
      'theme_design/m_header/sub_menu_font_family': '\'Poppins\'',
      'theme_design/m_header/sub_menu_text_transform': 'capitalize',
      'theme_design/m_header/sub_menu_font_size': '14',
      'theme_design/m_header/sub_menu_font_weight': '500'
    },
    'menu': {
      'theme_design/nav/outer_menu_bg_color': '#f0d8e7',
      'theme_design/nav/color': '#444',
      'theme_design/nav/hover_bg_color': '#f0d8e7',
      'theme_design/nav/hover_color': '#f20cb5',
      'theme_design/nav/font_family': '\'Poppins\'',
      'theme_design/nav/text_transform': 'capitalize',
      'theme_design/nav/font_size': '18',
      'theme_design/nav/font_weight': '600',
      'theme_design/nav/text_decoration': 'none',
      'theme_design/nav/text_decoration_hover': 'none',
      'theme_design/nav/letter_spacing': '0px',
      'theme_design/nav/is_menu_item_underline_effect': '0',
      'theme_design/nav/underline_height': '3px',
      'theme_design/nav/underline_color': '#fff',
      'theme_design/nav/dropdown_bg_color': '#f0d8e7',
      'theme_design/nav/dropdown_item_hover_bg_color': '#f0d8e7',
      'theme_design/nav/dropdown_link_color': '#444',
      'theme_design/nav/dropdown_link_hover_color': '#f20cb5',
      'theme_design/nav/dropdown_font_family': '\'Poppins\'',
      'theme_design/nav/dropdown_text_transform': 'capitalize',
      'theme_design/nav/dropdown_font_size': '18',
      'theme_design/nav/dropdown_font_weight': '600',
      'theme_design/nav/dropdown_text_decoration': 'none',
      'theme_design/nav/dropdown_text_decoration_hover': 'none',
      'theme_design/nav/dropdown_item_is_border_bottom': '0',
      'theme_design/nav/dropdown_item_border_bottom': 'none'
    },
    'footer': {
      'theme_design/footer/bg_color': '#f0d8e7',
      'theme_design/footer/color': '#444',
      'theme_design/footer/link_color': '#f20cb5',
      'theme_design/footer/link_hover_color': '#444',
      'theme_design/footer/border_top': 'none',
      'theme_design/footer/button_bg_color': '#f20cb5',
      'theme_design/footer/button_color': '#444',
      'theme_design/footer/button_hover_bg_color': '#fff',
      'theme_design/footer/button_hover_color': '#f20cb5',
      'theme_design/footer_bottom/color': '#fff',
      'theme_design/footer_bottom/link_color': '#f20cb5',
      'theme_design/footer_bottom/link_hover_color': '#fff',
      'theme_design/footer_bottom/bg_color': '#000',
      'theme_design/footer_tagline/bg_color': '#f0d8e7',
      'theme_design/footer_tagline/color': '#fff',
      'theme_design/footer_tagline/font_size': '32',
      'theme_design/footer_tagline/font_weight': '400',
      'theme_design/premium_plus_footer/text_transform': 'capitalize',
      'theme_design/premium_plus_footer/newsletter_bg_color': '#fff',
      'theme_design/premium_plus_footer/font_size': 'inherit',
      'theme_design/premium_plus_footer/font_weight': '400'
    },
    'category_page': {
      'theme_design/colors/price_color': '#f20cb5',
      'theme_design/colors/price_font_size': '16',
      'theme_design/colors/price_font_weight': '400',
      'theme_design/colors/rating_active_color': '#f0d8e7',
      'theme_design/colors/product_name_color': '#000',
      'theme_design/colors/product_name_font_size': '18',
      'theme_design/colors/product_name_font_weight': '400',
      'theme_design/colors/product_name_text_transform': 'capitalize',
      'theme_design/colors/product_name_text_align': 'center',
      'theme_design/category/category_promo_font_family': '\'Poppins\'',
      'theme_design/category/category_promo_font_size': '18',
      'theme_design/category/category_promo_font_weight': '700',
      'theme_design/category/category_promo_line_height': '1.5',
      'theme_design/category/category_promo_padding': '10',
      'theme_design/category/category_promo_bg_color': '#f5f5f5',
      'theme_design/category/category_promo_color': '#444'
    },
    'product_page': {
      'theme_design/product_page/product_promo_font_family': '\'Poppins\'',
      'theme_design/product_page/product_promo_font_size': '16',
      'theme_design/product_page/product_promo_font_weight': '600',
      'theme_design/product_page/product_promo_line_height': '1.5',
      'theme_design/product_page/product_promo_padding': '10',
      'theme_design/product_page/product_promo_bg_color': '#f5f5f5',
      'theme_design/product_page/product_promo_color': '#444',
      'theme_design/product_page/product_tabs_bg_color': '#f0d8e7',
      'theme_design/product_page/product_tabs_color': '#444',
      'theme_design/product_page/product_tabs_bg_color_active': '#444',
      'theme_design/product_page/product_tabs_color_active': '#f0d8e7'
    },
    'cart_page': {
      'theme_design/main/login_promo_bg_color': '#f0d8e7',
      'theme_design/main/login_promo_color': '#444',
      'theme_design/main/login_promo_title_font_size': '22',
      'theme_design/main/login_promo_title_font_weight': '400',
      'theme_design/main/login_promo_font_family': '\'Open Sans\'',
      'theme_design/main/login_promo_desc_font_size': '14',
      'theme_design/main/login_promo_text_transform': 'uppercase'
    },
    'homepage_cta': {
      'theme_design/cta/cta_mask_bg': 'rgba(240, 216, 231, 0.8)',
      'theme_design/cta/cta_mask_title_color': '#444',
      'theme_design/cta/cta_mask_link_color': '#444',
      'theme_design/cta/cta_mask_link_color_hover': '#f20cb5',
      'theme_design/cta/cta_mask_button_bg': '#f20cb5',
      'theme_design/cta/cta_mask_button_color': '#444',
      'theme_design/cta/cta_mask_button_bg_hover': '#fff',
      'theme_design/cta/cta_mask_button_color_hover': '#f20cb5',
      'theme_design/cta/button_border': '1px solid #f20cb5',
      'theme_design/cta/button_border_hover': '1px solid #f20cb5',
      'theme_design/cta/cta_vertical_title_color': '#fff',
      'theme_design/cta/cta_horizontal_top_title_color': '#fff',
      'theme_design/cta/cta_horizontal_bottom_title_color': '#fff',
      'theme_design/cta/cta_title_font_weight': '400'
    },
    'additional_header': {
      'theme_design/premium_plus_homepage/additional_header_bg': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_text_color': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_text_font_size': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_icon_color': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_text_color_hover': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_icon_color_hover': 'inherit'
    },
    'premium_plus_testimonials': {
      'theme_design/premium_plus_homepage/testimonials_bg': 'transparent',
      'theme_design/premium_plus_homepage/testimonials_block_text_color': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_text_font_size': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_text_transform': 'none',
      'theme_design/premium_plus_homepage/testimonials_block_text_font_weight': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_text_font_style': 'normal',
      'theme_design/premium_plus_homepage/testimonials_block_rating_color': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_rating_bg_color': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_author_color': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_author_font_size': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_author_font_weight': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_author_transform': 'none',
      'theme_design/premium_plus_homepage/testimonials_block_author_font_style': 'normal'
    },
    'premium_plus_blog': {
      'theme_design/premium_plus_homepage/blog_block_bg': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_main_heading_color': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_main_heading_font_size': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_text_color': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_text_font_size': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_bg': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_color': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_border_color': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_bg_hover': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_color_hover': 'inherit'
    },
    'premium_plus_instagram': {
      'theme_design/premium_plus_homepage/instagram_block_mask_bg': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_main_heading_color': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_main_heading_font_size': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_bg': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_color': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_border_color': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_bg_hover': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_color_hover': 'inherit'
    },
    'premium_plus_cta': {
      'theme_design/premium_plus_homepage/premium_plus_cta_title_color': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_title_font_size': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_title_transform': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_title_font_weight': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_title_font_style': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_item_bg': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_color': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_font_size': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_transform': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_font_weight': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_font_style': 'inherit'
    }
  },
  'Schema5': {
    'colors': {
      'theme_design/colors/color_primary': '#000',
      'theme_design/colors/color_secondry': '#e63d47',
      'theme_design/colors/color_additional': '#123b51',
      'theme_design/colors/color_primary_text_color': '#000'
    },
    'typography': {
      'theme_design/defined_fonts/google_fonts_string': 'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700;800&family=Titillium+Web:wght@400;600;700;800&display=swap',
      'theme_design/defined_fonts/font_stacks_string': 'Arial, \'Helvetica Neue\', Helvetica, sans-serif;',
      'theme_design/font/body_font_size': '16',
      'theme_design/font/body_font_family': '\'Titillium Web\'',
      'theme_design/font_fallback/body_font_stack': 'Arial, \'Helvetica Neue\', Helvetica, sans-serif',
      'theme_design/font/heading1_font_family': '\'Titillium Web\'',
      'theme_design/font/heading1_font_color': '#032f41',
      'theme_design/font/heading1_font_size': '30',
      'theme_design/font/heading1_font_weight': '400',
      'theme_design/font/heading1_text_transform': 'capitalize',
      'theme_design/font/heading1_line_height': '1.2',
      'theme_design/font/heading2_font_family': '\'Titillium Web\'',
      'theme_design/font/heading2_font_color': '#032f41',
      'theme_design/font/heading2_font_size': '28',
      'theme_design/font/heading2_font_weight': '400',
      'theme_design/font/heading2_text_transform': 'capitalize',
      'theme_design/font/heading2_line_height': '1.2',
      'theme_design/font/heading3_font_family': '\'Titillium Web\'',
      'theme_design/font/heading3_font_color': '#032f41',
      'theme_design/font/heading3_font_size': '24',
      'theme_design/font/heading3_font_weight': '400',
      'theme_design/font/heading3_text_transform': 'capitalize',
      'theme_design/font/heading3_line_height': '1.2',
      'theme_design/font/heading4_font_family': '\'Titillium Web\'',
      'theme_design/font/heading4_font_color': '#032f41',
      'theme_design/font/heading4_font_size': '20',
      'theme_design/font/heading4_font_weight': '400',
      'theme_design/font/heading4_text_transform': 'uppercase',
      'theme_design/font/heading4_line_height': '1.2',
      'theme_design/font/heading5_font_family': '\'Titillium Web\'',
      'theme_design/font/heading5_font_color': '#032f41',
      'theme_design/font/heading5_font_size': '18',
      'theme_design/font/heading5_font_weight': '400',
      'theme_design/font/heading5_text_transform': 'capitalize',
      'theme_design/font/heading5_line_height': '1.2',
      'theme_design/font/heading6_font_family': '\'Titillium Web\'',
      'theme_design/font/heading6_font_color': '#032f41',
      'theme_design/font/heading6_font_size': '16',
      'theme_design/font/heading6_font_weight': '400',
      'theme_design/font/heading6_text_transform': 'capitalize',
      'theme_design/font/heading6_line_height': '1.2',
      'theme_design/font/paragraph_font_family': '\'Titillium Web\'',
      'theme_design/font/paragraph_font_color': '#000',
      'theme_design/font/paragraph_font_size': '16',
      'theme_design/font/paragraph_line_height': '1.4',
      'theme_design/font/list_style_type': 'disc'
    },
    'links': {
      'theme_design/colors/link_color': '#000',
      'theme_design/colors/link_hover_color': '#000',
      'theme_design/colors/link_text_decoration': 'underline',
      'theme_design/colors/link_text_decoration_hover': 'underline',
      'theme_design/colors/link_font_weight': '400'
    },
    'buttons': {
      'theme_design/colors/button_bg_color': '#e63d47',
      'theme_design/colors/button_color': '#fff',
      'theme_design/colors/button_hover_bg_color': '#b12d34',
      'theme_design/colors/button_hover_color': '#fff',
      'theme_design/colors/button_font_size': '13',
      'theme_design/colors/button_font_family': '\'Titillium Web\'',
      'theme_design/colors/button_text_transform': 'uppercase',
      'theme_design/colors/button_font_weight': '700',
      'theme_design/colors/button_font_style': 'normal',
      'theme_design/colors/button_border_radius': '5px',
      'theme_design/colors/button_border': 'none',
      'theme_design/colors/button_border_hover': 'none'
    },
    'labels': {
      'theme_design/colors/label_new_bg_color': '#e63d47',
      'theme_design/colors/label_new_color': '#000',
      'theme_design/colors/label_sale_bg_color': '#e63d47',
      'theme_design/colors/label_sale_color': '#000',
    },
    'header': {
      'theme_design/header/header_bg_color': '#fff',
      'theme_design/header/top_border_color': '#fff',
      'theme_design/header_primary/text_font_size': '14',
      'theme_design/header_primary/text_color': '#000',
      'theme_design/header_primary/text_link_color': '#000',
      'theme_design/header_primary/text_link_hover_color': '#000',
      'theme_design/header_primary/button_color': '#fff',
      'theme_design/header_primary/button_hover_color': '#fff',
      'theme_design/header_primary/button_background': '#e63d47',
      'theme_design/header_primary/button_hover_background': '#b12d34'
    },
    'mobile': {
      'theme_design/m_header/tab_item_bg_color': '#fff',
      'theme_design/m_header/tab_item_color': '#000',
      'theme_design/m_header/counter_bg_color': '#000',
      'theme_design/m_header/counter_bg_active_color': '#fff',
      'theme_design/m_header/sub_menu_bg': '#fff',
      'theme_design/m_header/sub_menu_color': '#333',
      'theme_design/m_header/sub_menu_font_family': '\'Titillium Web\'',
      'theme_design/m_header/sub_menu_text_transform': 'uppercase',
      'theme_design/m_header/sub_menu_font_size': '16',
      'theme_design/m_header/sub_menu_font_weight': '600'
    },
    'menu': {
      'theme_design/nav/outer_menu_bg_color': '#fff',
      'theme_design/nav/color': '#000',
      'theme_design/nav/hover_bg_color': 'rgba(0, 0, 0, 0)',
      'theme_design/nav/hover_color': '#000',
      'theme_design/nav/font_family': '\'Titillium Web\'',
      'theme_design/nav/text_transform': 'uppercase',
      'theme_design/nav/font_size': '16',
      'theme_design/nav/font_weight': '400',
      'theme_design/nav/text_decoration': 'none',
      'theme_design/nav/text_decoration_hover': 'underline',
      'theme_design/nav/letter_spacing': '0px',
      'theme_design/nav/is_menu_item_underline_effect': '0',
      'theme_design/nav/underline_height': '3px',
      'theme_design/nav/underline_color': '#fff',
      'theme_design/nav/dropdown_bg_color': '#fff',
      'theme_design/nav/dropdown_item_hover_bg_color': '#fff',
      'theme_design/nav/dropdown_link_color': '#000',
      'theme_design/nav/dropdown_link_hover_color': '#000',
      'theme_design/nav/dropdown_font_family': '\'Titillium Web\'',
      'theme_design/nav/dropdown_text_transform': 'uppercase',
      'theme_design/nav/dropdown_font_size': '16',
      'theme_design/nav/dropdown_font_weight': '400',
      'theme_design/nav/dropdown_text_decoration': 'none',
      'theme_design/nav/dropdown_text_decoration_hover': 'underline',
      'theme_design/nav/dropdown_item_is_border_bottom': '0',
      'theme_design/nav/dropdown_item_border_bottom': 'none'
    },
    'footer': {
      'theme_design/footer/bg_color': '#000',
      'theme_design/footer/color': '#fff',
      'theme_design/footer/link_color': '#fff',
      'theme_design/footer/link_hover_color': '#e63d47',
      'theme_design/footer/border_top': 'none',
      'theme_design/footer/button_bg_color': '#e63d47',
      'theme_design/footer/button_color': '#fff',
      'theme_design/footer/button_hover_bg_color': '#b12d34',
      'theme_design/footer/button_hover_color': '#fff',
      'theme_design/footer_bottom/color': '#000',
      'theme_design/footer_bottom/link_color': '#fff',
      'theme_design/footer_bottom/link_hover_color': '#000',
      'theme_design/footer_bottom/bg_color': '#e63d47',
      'theme_design/footer_tagline/bg_color': '#000',
      'theme_design/footer_tagline/color': '#fff',
      'theme_design/footer_tagline/font_size': '32',
      'theme_design/footer_tagline/font_weight': '400',
      'theme_design/premium_plus_footer/text_transform': 'capitalize',
      'theme_design/premium_plus_footer/newsletter_bg_color': '#fff',
      'theme_design/premium_plus_footer/font_size': 'inherit',
      'theme_design/premium_plus_footer/font_weight': '400'
    },
    'category_page': {
      'theme_design/colors/price_color': '#e63d47',
      'theme_design/colors/price_font_size': '16',
      'theme_design/colors/price_font_weight': '400',
      'theme_design/colors/rating_active_color': '#e63d47',
      'theme_design/colors/product_name_color': '#032f41',
      'theme_design/colors/product_name_font_size': '18',
      'theme_design/colors/product_name_font_weight': '400',
      'theme_design/colors/product_name_text_transform': 'capitalize',
      'theme_design/colors/product_name_text_align': 'center',
      'theme_design/category/category_promo_font_family': '\'Montserrat\'',
      'theme_design/category/category_promo_font_size': '18',
      'theme_design/category/category_promo_font_weight': '700',
      'theme_design/category/category_promo_line_height': '1.2',
      'theme_design/category/category_promo_padding': '10',
      'theme_design/category/category_promo_bg_color': '#f5f5f5',
      'theme_design/category/category_promo_color': '#333'
    },
    'product_page': {
      'theme_design/product_page/product_promo_font_family': '\'Montserrat\'',
      'theme_design/product_page/product_promo_font_size': '16',
      'theme_design/product_page/product_promo_font_weight': '600',
      'theme_design/product_page/product_promo_line_height': '1.2',
      'theme_design/product_page/product_promo_padding': '10',
      'theme_design/product_page/product_promo_bg_color': '#f5f5f5',
      'theme_design/product_page/product_promo_color': '#333',
      'theme_design/product_page/product_tabs_bg_color': '#e63d47',
      'theme_design/product_page/product_tabs_color': '#fff',
      'theme_design/product_page/product_tabs_bg_color_active': '#b12d34',
      'theme_design/product_page/product_tabs_color_active': '#fff'
    },
    'cart_page': {
      'theme_design/main/login_promo_bg_color': '#e63d47',
      'theme_design/main/login_promo_color': '#fff',
      'theme_design/main/login_promo_title_font_size': '22',
      'theme_design/main/login_promo_title_font_weight': '400',
      'theme_design/main/login_promo_font_family': '\'Montserrat\'',
      'theme_design/main/login_promo_desc_font_size': '14',
      'theme_design/main/login_promo_text_transform': 'uppercase'
    },
    'homepage_cta': {
      'theme_design/cta/cta_mask_bg': 'rgba(18, 59, 81, 0.8)',
      'theme_design/cta/cta_mask_title_color': '#fff',
      'theme_design/cta/cta_mask_link_color': '#fff',
      'theme_design/cta/cta_mask_link_color_hover': '#e63d47',
      'theme_design/cta/cta_mask_button_bg': '#e63d47',
      'theme_design/cta/cta_mask_button_color': '#fff',
      'theme_design/cta/cta_mask_button_bg_hover': '#b12d34',
      'theme_design/cta/cta_mask_button_color_hover': '#fff',
      'theme_design/cta/button_border': 'none',
      'theme_design/cta/button_border_hover': 'none',
      'theme_design/cta/cta_vertical_title_color': '#fff',
      'theme_design/cta/cta_horizontal_top_title_color': '#fff',
      'theme_design/cta/cta_horizontal_bottom_title_color': '#fff',
      'theme_design/cta/cta_title_font_weight': '400'
    },
    'additional_header': {
      'theme_design/premium_plus_homepage/additional_header_bg': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_text_color': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_text_font_size': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_icon_color': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_text_color_hover': 'inherit',
      'theme_design/premium_plus_homepage/additional_header_icon_color_hover': 'inherit'
    },
    'premium_plus_testimonials': {
      'theme_design/premium_plus_homepage/testimonials_bg': 'transparent',
      'theme_design/premium_plus_homepage/testimonials_block_text_color': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_text_font_size': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_text_transform': 'none',
      'theme_design/premium_plus_homepage/testimonials_block_text_font_weight': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_text_font_style': 'normal',
      'theme_design/premium_plus_homepage/testimonials_block_rating_color': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_rating_bg_color': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_author_color': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_author_font_size': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_author_font_weight': 'inherit',
      'theme_design/premium_plus_homepage/testimonials_block_author_transform': 'none',
      'theme_design/premium_plus_homepage/testimonials_block_author_font_style': 'normal'
    },
    'premium_plus_blog': {
      'theme_design/premium_plus_homepage/blog_block_bg': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_main_heading_color': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_main_heading_font_size': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_text_color': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_text_font_size': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_bg': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_color': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_border_color': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_bg_hover': 'inherit',
      'theme_design/premium_plus_homepage/blog_block_button_color_hover': 'inherit'
    },
    'premium_plus_instagram': {
      'theme_design/premium_plus_homepage/instagram_block_mask_bg': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_main_heading_color': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_main_heading_font_size': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_bg': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_color': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_border_color': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_bg_hover': 'inherit',
      'theme_design/premium_plus_homepage/instagram_block_button_color_hover': 'inherit'
    },
    'premium_plus_cta': {
      'theme_design/premium_plus_homepage/premium_plus_cta_title_color': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_title_font_size': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_title_transform': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_title_font_weight': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_title_font_style': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_item_bg': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_color': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_font_size': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_transform': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_font_weight': 'inherit',
      'theme_design/premium_plus_homepage/premium_plus_cta_text_font_style': 'inherit'
    }
  }
};
